import { useQuery } from '@tanstack/react-query'
import { com, kotlin } from '@eidu/web'
import getPermittedActions from './api/entity/permission/getPermittedActions'
import { permittedActionsKeys } from './queryKeys'
import PermittedActions = com.eidu.sharedlib.entity.permission.PermittedActions
import KtList = kotlin.collections.KtList
import PermittedAction = com.eidu.sharedlib.entity.permission.PermittedAction

type UsePermittedActionsResult = {
  permissions: readonly PermittedAction[] | undefined
  error: string | undefined
  isLoading: boolean
}

const usePermittedActions = (requested: readonly PermittedAction[]): UsePermittedActionsResult => {
  const query = useQuery({
    queryKey: permittedActionsKeys.forRequest([...requested.map((it) => it.toString())].sort()),
    queryFn: async () => {
      const userPermissions = await getPermittedActions({
        requested: new PermittedActions(KtList.fromJsArray(requested)),
      })
      return userPermissions.permittedActions.asJsReadonlyArrayView()
    },
  })

  return {
    permissions: query.data,
    error: query.error ? (query.error instanceof Error ? query.error.toString() : String(query.error)) : undefined,
    isLoading: query.isLoading,
  }
}

export default usePermittedActions
